<div class="comparison-header mb-4">
  <div>
    <div class="comparison-title">Comparativa de Partido (1 vs 1)</div>
    <div class="comparison-score" *ngIf="hasScore; else noScore">
      {{ teamLabel }}: <strong>{{ teamScore }}</strong>
      <span class="mx-1">·</span>
      {{ opponentLabel }}: <strong>{{ opponentScore }}</strong>
    </div>
    <ng-template #noScore>
      <div class="comparison-score muted">Marcador no disponible</div>
    </ng-template>
  </div>
  <div class="comparison-pills">
    <span class="team-pill">{{ teamLabel }}</span>
    <span class="opponent-pill">{{ opponentLabel }}</span>
  </div>
</div>

<div class="kpi-section mb-5">
  <div class="section-label team-label">{{ teamLabel }}</div>
  <app-stats-ai-dashboard [stats]="teamStats" [sections]="kpiSections" [singleMatchMode]="true"></app-stats-ai-dashboard>
</div>

<div class="kpi-section mb-5">
  <div class="section-label opponent-label">{{ opponentLabel }}</div>
  <app-stats-ai-dashboard [stats]="opponentStats" [sections]="kpiSections" [singleMatchMode]="true"></app-stats-ai-dashboard>
</div>

<div *ngFor="let block of compactBlocks" class="comparison-block mb-5">
  <div class="block-title mb-2">{{ block.title }}</div>
  <div class="row g-4">
    <div class="col-12 col-xl-6">
      <div class="section-label team-label">{{ teamLabel }}</div>
      <app-stats-ai-dashboard [stats]="teamStats" [sections]="[block.section]" [singleMatchMode]="true"></app-stats-ai-dashboard>
    </div>
    <div class="col-12 col-xl-6">
      <div class="section-label opponent-label">{{ opponentLabel }}</div>
      <app-stats-ai-dashboard [stats]="opponentStats" [sections]="[block.section]" [singleMatchMode]="true"></app-stats-ai-dashboard>
    </div>
  </div>
</div>

<div *ngFor="let block of largeBlocks" class="comparison-block mb-5">
  <div class="block-title mb-2">{{ block.title }}</div>
  <div class="section-label team-label">{{ teamLabel }}</div>
  <app-stats-ai-dashboard [stats]="teamStats" [sections]="[block.section]" [singleMatchMode]="true"></app-stats-ai-dashboard>

  <div class="section-label opponent-label mt-4">{{ opponentLabel }}</div>
  <app-stats-ai-dashboard [stats]="opponentStats" [sections]="[block.section]" [singleMatchMode]="true"></app-stats-ai-dashboard>
</div>
